import { supportEmail } from '../domain/supportContact';

export function composeEmail(subject: string, body: string): boolean {
  const uri = `mailto:${supportEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  try {
    window.location.href = uri;
    return true;
  } catch {
    return false;
  }
}
